var render = function (_h,_vm) {var _c=_vm._c;return _c(_vm.props.component,{tag:"component",staticClass:"py-3",class:{ 'bg-light': _vm.props.alternate }},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }